// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylesheets/widgets/metadataWidget.styl
// module id = 402
// module chunks = 0